import { ReportItem } from "./types";
import { permissions } from "../../constants";
import { useI18n } from "../../hooks/useI18n";

export const getReportItems = (): ReadonlyArray<ReportItem> => {
  const { t } = useI18n();

  return [
    {
      name: t("reports.vatReport"),
      path: "/vat-revenues",
      permissions: ["Root", "Economy", "StoreManager"],
      fileTypes: ["excel", "pdf", "csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    {
      name: t("reports.swishTransactions"),
      path: "/swish-purchase-transactions",
      permissions: ["Root", "Economy", "StoreManager"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    {
      name: t("reports.rawPurchaseTransactions"),
      path: "/raw-purchase-transactions",
      permissions: ["Root"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    {
      name: t("reports.transactionsContainingUserInfo"),
      path: "/purchase-transactions-containing-users",
      permissions: ["Root"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    {
      name: t("reports.soldProducts"),
      path: "/product-purchase-transactions",
      permissions: ["Root", "Economy", "StoreManager"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },

    {
      name: t("reports.purchaseTransactions"),
      path: "/purchase-transactions",
      permissions: ["Root", "Economy", "StoreManager"],
      fileTypes: ["excel", "sei4"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    // {
    //   name: "Click & Collect ordrar",
    //   path: "/cnc-orders",
    //   permissions: [
    //     "Root",
    //     "Economy",
    //     "Marketing",
    //     "StoreManager",
    //     "FranchiseManager",
    //     "AssortmentManager"
    //   ],
    //   fileTypes: ["csv"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   name: "Dagsförsäljning (för perioden, per butik)",
    //   path: "/daily-sales",
    //   permissions: ["Root", "Economy", "Marketing", "AssortmentManager"],
    //   fileTypes: ["excel"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   name: "Försäljning (för perioden, per butik)",
    //   path: "/sales",
    //   permissions: [],
    //   fileTypes: ["excel"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   name: "Detaljerad försäljning (för perioden, per butik)",
    //   path: "/detailed-sales",
    //   permissions: ["Root", "Economy", "Marketing", "AssortmentManager"],
    //   fileTypes: ["excel"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: true
    //     }
    //   ]
    // },
    // {
    //   name: "Försäljning (totalt per användare)",
    //   path: "/user-sales",
    //   permissions: [],
    //   fileTypes: ["excel"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: false
    //     },
    //     {
    //       displayName: "Include deleted",
    //       variableName: "includeDeleted",
    //       type: "boolean",
    //       required: false
    //     },
    //     {
    //       displayName: "Include non-purchasing",
    //       variableName: "includeNonPurchasing",
    //       type: "boolean",
    //       defaultValue: true,
    //       required: false
    //     }
    //   ]
    // },
    // {
    //   name: "Försäljning (för perioden, per butik och produkt)",
    //   path: "/sales-per-store-and-product",
    //   permissions: [],
    //   fileTypes: ["csv"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: true
    //     },
    //     {
    //       displayName: "Group by week",
    //       variableName: "groupByWeek",
    //       type: "boolean",
    //       required: false
    //     }
    //   ]
    // },
    // {
    //   name: "Försäljning (för perioden, per butik, användare och produkt)",
    //   path: "/sales-per-user-and-product",
    //   permissions: [],
    //   fileTypes: ["excel"],
    //   parameters: [
    //     {
    //       displayName: "Period",
    //       variableName: "period",
    //       type: "dateSpan",
    //       required: true
    //     }
    //   ]
    // },
    {
      name: t("reports.productSpoilage"),
      path: "/product-spoilage",
      permissions: [],
      fileTypes: ["excel"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    // {
    //   name: "Produktsortiment",
    //   path: "/products",
    //   permissions: ["Root", "Economy", "Marketing", "AssortmentManager"],
    //   fileTypes: ["excel"],
    //   parameters: [
    //     {
    //       displayName: "Show only products in store",
    //       variableName: "showInStoreOnly",
    //       type: "boolean",
    //       required: false
    //     }
    //   ]
    // },
    {
      name: t("reports.stockTaking"),
      path: "/stock-taking",
      permissions: [
        "Root",
        "Economy",
        "StoreManager",
        "FranchiseManager",
        "AssortmentManager"
      ],
      fileTypes: ["excel"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateSpan",
          required: true
        }
      ]
    },
    {
      name: t("reports.usersThatOpenDoorsWithoutPurchases"),
      path: "/users-without-purchase",
      permissions: ["Root", "Economy", "StoreManager"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateTimeSpan",
          required: true
        },
        {
          displayName: t("reports.parameters.nrOfDoorOpenings"),
          variableName: "nrOfDoorOpenings",
          type: "number",
          required: false
        }
      ]
    },
    {
      name: t("reports.usersWithLowPurchaseAmount"),
      path: "/users-with-low-purchase-amount",
      permissions: ["Root", "Economy", "StoreManager"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.purchaseAmount"),
          variableName: "purchaseAmount",
          type: "number",
          required: false
        },
        {
          displayName: t("reports.parameters.userAveragePurchaseAmount"),
          variableName: "userAveragePurchaseAmount",
          type: "number",
          required: false
        },
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateTimeSpan",
          required: true
        }
      ]
    },
    {
      name: t("reports.usersThatOpenDoorsInMultipleStores"),
      path: "/users-that-open-doors-in-multiple-stores",
      permissions: ["Root"],
      fileTypes: ["csv"],
      parameters: [
        {
          displayName: t("reports.parameters.period"),
          variableName: "period",
          type: "dateTimeSpan",
          required: true
        }
      ]
    }
  ];
};
